<gallery gallerize [items]="items"
         loadingStrategy="lazy"
         thumbPosition="top"></gallery>
